/* ============================================================================
   collection.js  —  v12.0.0 Collection Architecture Rebuild (Stage 1 + 2)
   ONE consolidated script for every collection page-type.
   Stage 1: verbatim concatenation of the four inline behavioural <script>
            IIFEs from the v11.88.3 collection sections. Each IIFE self-guards
            on its own DOM hooks and is a no-op when its section is absent.
   Stage 2: the diamond-first banner is hoisted out of editorial's IIFE into
            a shared block (below) that runs on every collection page —
            editorial's shape filter + JS-fetch pagination stay editorial-only.
   The outer guard makes a double <script> load (generic pages emit banner
   + grid) idempotent.
   collection-grid behaviour already lives in assets/theme.js — untouched.
   ========================================================================== */
(function () {
  if (window.__MYCollectionJS) return;   /* load-once guard */
  window.__MYCollectionJS = true;

  /* ===== v13.5.0 — Excluded collections =====
     Collections where diamonds are pre-set / curated (customer picks the
     ring; the diamond is already assigned) and must NEVER be part of the
     diamond-first flow. On these pages the banner, product-card rewrites,
     shape filter, and JS-fetch pagination are all skipped, regardless of
     what's in localStorage.

     Add handles below to extend the list. Match is against the URL path
     `/collections/<handle>` prefix, so sub-paths (filters, sort params)
     still resolve. */
  var DIAMOND_FLOW_EXCLUDED_COLLECTIONS = [
    'lab-grown-diamond-rings'
  ];
  function isDiamondFlowExcluded() {
    var p = (window.location.pathname || '').toLowerCase();
    for (var i = 0; i < DIAMOND_FLOW_EXCLUDED_COLLECTIONS.length; i++) {
      var h = DIAMOND_FLOW_EXCLUDED_COLLECTIONS[i];
      if (p === '/collections/' + h) return true;
      if (p.indexOf('/collections/' + h + '/') === 0) return true;
      if (p.indexOf('/collections/' + h + '?') === 0) return true;
    }
    return false;
  }

/* ===== Shared: diamond-first banner (every collection page) =====
   Hoisted out of editorial's IIFE in Stage 2/Directive 2 so the
   "Step 2 of 3 — Select Your Setting" banner shows on every collection
   page when the customer arrived from Diamond Search with a chosen
   diamond. Editorial's shape filter + JS-fetch pagination stay below. */
  (function diamondFirstBanner(){
    if (isDiamondFlowExcluded()) return;
    var raw;
    try { raw = localStorage.getItem('myd_selected_diamond'); } catch(_) { return; }
    if (!raw) return;

    var d;
    try { d = JSON.parse(raw); } catch(_) { return; }

    // Build the human-readable summary, e.g. "1.50ct D VS1 Cushion"
    var ct  = d.carats  ? parseFloat(d.carats).toFixed(2) + 'ct ' : '';
    var col = d.color   ? d.color + ' ' : '';
    var cla = d.clarity ? d.clarity + ' ' : '';
    var sh  = d.shape   ? d.shape.toLowerCase().replace(/(^|\s)\S/g, function(t){ return t.toUpperCase(); }) : '';
    var summary = (ct + col + cla + sh).trim();
    var label = summary
      ? 'Select a setting for your ' + summary + ' diamond.'
      : 'Select a setting for your chosen diamond.';

    // Use the markup banner if present (editorial pages); inject one otherwise.
    var banner = document.getElementById('mye-diamond-banner');
    if (banner) {
      var textEl = document.getElementById('mye-diamond-banner-text');
      if (textEl) textEl.textContent = label;
      banner.removeAttribute('hidden');
    } else {
      banner = document.createElement('div');
      banner.className = 'mye-diamond-banner';
      banner.id = 'mye-diamond-banner';
      banner.setAttribute('data-mye-diamond-banner', '');
      banner.innerHTML =
        '<div class="mye-diamond-banner-info">' +
          '<p class="mye-diamond-banner-step">Step 2 of 3, Select Your Setting</p>' +
          '<p class="mye-diamond-banner-text" id="mye-diamond-banner-text"></p>' +
          '<p class="mye-diamond-banner-loading" id="mye-diamond-banner-loading" hidden>Loading more matching settings\u2026</p>' +
        '</div>' +
        '<div class="mye-diamond-banner-actions">' +
          '<a class="mye-diamond-banner-back" href="/pages/diamond-search">\u2190 Back to diamond search</a>' +
          '<button type="button" class="mye-diamond-banner-clear" id="mye-diamond-banner-clear" aria-label="Clear selected diamond and browse all settings">Clear diamond</button>' +
        '</div>';
      var textEl2 = banner.querySelector('#mye-diamond-banner-text');
      if (textEl2) textEl2.textContent = label;
      var anchor = document.querySelector('main') || document.body;
      anchor.insertBefore(banner, anchor.firstChild);
    }

    // CLEAR DIAMOND — removeItem, strip the cosmetic diamond_selected param,
    // and reload to a clean state (per Directive 2: uniform reload UX across
    // every collection page).
    var clearBtn = document.getElementById('mye-diamond-banner-clear');
    if (clearBtn) {
      clearBtn.addEventListener('click', function(){
        try { localStorage.removeItem('myd_selected_diamond'); } catch(_) {}
        try {
          var url = new URL(window.location.href);
          url.searchParams.delete('diamond_selected');
          window.location.href = url.toString();
        } catch(_) {
          window.location.reload();
        }
      });
    }
  })();


/* ===== collection-editorial behaviour ===== */
  (function(){
    var root = document.querySelector('[data-mye-root]');
    if (!root) return;

    // Filter group collapse/expand
    root.querySelectorAll('[data-mye-group-toggle]').forEach(function(btn){
      btn.addEventListener('click', function(){
        var group = btn.closest('[data-mye-group]');
        if (!group) return;
        var expanded = group.getAttribute('aria-expanded') === 'true';
        group.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      });
    });

    // Auto-submit form when checkbox filter changes
    var form = root.querySelector('#mye-filter-form');
    root.querySelectorAll('[data-mye-auto-submit]').forEach(function(cb){
      cb.addEventListener('change', function(){ if (form) form.submit(); });
    });

    // Sort select auto-submit (redirects on change)
    var sortSelect = root.querySelector('[data-mye-sort]');
    if (sortSelect) {
      sortSelect.addEventListener('change', function(){
        var url = new URL(window.location.href);
        if (sortSelect.value) url.searchParams.set('sort_by', sortSelect.value);
        else url.searchParams.delete('sort_by');
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    }

    // Diamond type toggle (tag-based filter via URL param 'filter.p.tag')
    root.querySelectorAll('.mye-dtt-btn').forEach(function(btn){
      btn.addEventListener('click', function(){
        root.querySelectorAll('.mye-dtt-btn').forEach(function(b){
          b.classList.remove('is-active');
          b.setAttribute('aria-selected', 'false');
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-selected', 'true');
        var type = btn.getAttribute('data-mye-dtype');
        var url = new URL(window.location.href);
        url.searchParams.delete('filter.p.tag');
        url.searchParams.delete('page');
        if (type === 'natural') url.searchParams.append('filter.p.tag', 'natural');
        else if (type === 'lab') url.searchParams.append('filter.p.tag', 'lab-grown');
        window.location.href = url.toString();
      });
    });

    // Mobile filter drawer
    var sidebar = root.querySelector('#mye-sidebar');
    var overlay = root.querySelector('[data-mye-filter-overlay]');
    var openBtn = root.querySelector('[data-mye-filter-open]');
    function openDrawer(){
      if (sidebar) sidebar.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    function closeDrawer(){
      if (sidebar) sidebar.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }
    if (openBtn) openBtn.addEventListener('click', openDrawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function(e){
      if (e.key === 'Escape' && sidebar && sidebar.classList.contains('is-open')) closeDrawer();
    });

    // ─────────────────────────────────────────────────────────────────
    // v11.48.0 — Diamond-first Build Ring flow
    //
    // When the customer arrived from Diamond Search with a chosen
    // diamond (myd_selected_diamond in localStorage):
    //
    //   1. Show the banner (with diamond summary + Clear button).
    //   2. JS-fetch any additional Shopify pagination pages so the
    //      grid has every product — not just page 1's 12 cards.
    //      This only runs when the customer is actually in the flow;
    //      normal /collections/engagement visits stay paginated at 12,
    //      keeping their initial load fast.
    //   3. Filter the (now-complete) grid by custom.supported_shapes,
    //      hiding cards whose supported shapes don't include the
    //      customer's diamond shape.
    //
    // Failures (localStorage, JSON parse, network) gracefully fall
    // back to the unfiltered default-paginated view.
    //
    // v13.5.0: excluded collections skip this entire flow — diamonds
    // on those pages are pre-set, not swappable.
    // ─────────────────────────────────────────────────────────────────
    if (isDiamondFlowExcluded()) return;
    try {
      var savedDiamond = localStorage.getItem('myd_selected_diamond');
      if (!savedDiamond) return;

      var d = JSON.parse(savedDiamond);
      var bannerText = document.getElementById('mye-diamond-banner-text');
      var bannerLoading = document.getElementById('mye-diamond-banner-loading');
      var diamondShape = (d.shape || '').toLowerCase().trim();

      // v11.50.0: hide the "Design a custom ring" nudge while the customer
      // is in the diamond-first flow. The flow has its own top-of-page
      // banner with the active CTAs (Back / Clear) — a second mid-scroll
      // "design custom" prompt is just noise here. Also dodges the grid-
      // auto-flow gap problem that arose when filtered cards left empty
      // cells before the nudge.
      var nudgeEl = root.querySelector('.mye-nudge');
      if (nudgeEl) nudgeEl.style.display = 'none';

      if (!diamondShape) return;

      // v11.48.0: Style-based exclusions — styles that don't fit a diamond-first
      // flow regardless of supported_shapes. "Gemstone" rings have non-diamond
      // centre stones (sapphires, citrine, etc.) — the customer picked a
      // diamond so these shouldn't appear. "Men's Engagement Ring" is mostly
      // band-style without a centre diamond position; supported_shapes is
      // typically empty for these, which would otherwise fail-open and let
      // them slip through.
      var EXCLUDED_STYLES = ['gemstone', "men's engagement ring"];

      function isStyleExcluded(card) {
        var styleAttr = (card.getAttribute('data-style') || '').toLowerCase();
        if (!styleAttr) return false;
        var styles = styleAttr.split(',').map(function(s){ return s.trim(); }).filter(Boolean);
        return styles.some(function(s){ return EXCLUDED_STYLES.indexOf(s) !== -1; });
      }

      // ── Filter function — applied after we have all cards in the DOM ──
      function applyShapeFilter() {
        var cards = root.querySelectorAll('.mye-card');
        var matchCount = 0;
        var totalWithData = 0;
        cards.forEach(function(card){
          // First: style-based exclusion. Hide unconditionally if style is in
          // the EXCLUDED list. This overrides the supported_shapes fail-open.
          if (isStyleExcluded(card)) {
            card.style.display = 'none';
            return;
          }
          var raw = (card.getAttribute('data-supported-shapes') || '').toLowerCase().trim();
          if (!raw) { card.style.display = ''; return; } // no data → leave visible (fail-open)
          totalWithData++;
          var supported = raw.split(',').map(function(s){ return s.trim(); }).filter(Boolean);
          var matches = supported.some(function(s){
            // tolerant match: either exact, or one contains the other (handles
            // "round brilliant" vs "round", "cushion modified" vs "cushion", etc.)
            return s === diamondShape || s.indexOf(diamondShape) !== -1 || diamondShape.indexOf(s) !== -1;
          });
          if (matches) { matchCount++; card.style.display = ''; }
          else card.style.display = 'none';
        });
        // If we hid every card with data, fall back to showing all — but still
        // keep the style-based exclusions in place. Better UX than an empty page
        // when supported_shapes coverage is thin, without resurrecting gemstone
        // / men's rings that shouldn't be in the diamond flow.
        if (totalWithData > 0 && matchCount === 0) {
          cards.forEach(function(card){
            if (!isStyleExcluded(card)) card.style.display = '';
          });
          if (bannerText && bannerText.dataset.fallbackApplied !== '1') {
            bannerText.dataset.fallbackApplied = '1';
            bannerText.textContent = bannerText.textContent
              + ' (No exact match, showing our full setting range.)';
          }
        }
      }

      // Run the filter on the cards that are already in the DOM (page 1).
      applyShapeFilter();

      // ── JS-fetch pagination ──
      // If there are more pages, fetch them in parallel via Shopify's HTML
      // pagination endpoint, extract the .mye-card nodes, append them to the
      // grid, then re-apply the filter. Total pages is rendered by Liquid into
      // data-mye-total-pages on the section root.
      var totalPages = parseInt(root.getAttribute('data-mye-total-pages'), 10) || 1;
      var currentPage = parseInt(root.getAttribute('data-mye-current-page'), 10) || 1;
      if (totalPages > 1 && currentPage === 1) {
        var grid = root.querySelector('.mye-grid');
        if (!grid) return;
        if (bannerLoading) bannerLoading.removeAttribute('hidden');

        var fetches = [];
        for (var p = 2; p <= totalPages; p++) {
          var pageUrl = new URL(window.location.href);
          pageUrl.searchParams.set('page', String(p));
          fetches.push(
            fetch(pageUrl.toString(), { credentials: 'same-origin' })
              .then(function(r) {
                if (!r.ok) throw new Error('HTTP ' + r.status);
                return r.text();
              })
              .then(function(html) {
                var doc = new DOMParser().parseFromString(html, 'text/html');
                return Array.prototype.slice.call(doc.querySelectorAll('.mye-card'));
              })
              .catch(function() { return []; }) // swallow individual fetch failures
          );
        }

        Promise.all(fetches).then(function(arrays) {
          arrays.forEach(function(cards) {
            cards.forEach(function(card) { grid.appendChild(card); });
          });
          if (bannerLoading) bannerLoading.setAttribute('hidden', '');
          // Hide the server-rendered pagination — we've loaded every page
          // client-side, so "Previous / Load More" buttons would be wrong.
          var paginationEl = root.querySelector('.mye-pagination');
          if (paginationEl) paginationEl.style.display = 'none';
          // Re-run the filter on the now-complete grid.
          applyShapeFilter();
        }).catch(function() {
          // Network failure on the JS-fetch — leave the page in its
          // server-rendered state. The filter has already run once on
          // page 1's cards, so the user still sees the matching subset
          // of the first 12 rings.
          if (bannerLoading) bannerLoading.setAttribute('hidden', '');
        });
      }
    } catch(e) {
      // localStorage / JSON parse failure → page renders normally, no banner.
    }
  })();

/* ===== collection-engagement behaviour ===== */
  (function(){
    var root = document.querySelector('[data-eng-root]');
    if (!root) return;

    // Filter group collapse/expand
    root.querySelectorAll('[data-eng-group-toggle]').forEach(function(btn){
      btn.addEventListener('click', function(){
        var group = btn.closest('[data-eng-group]');
        if (!group) return;
        var expanded = group.getAttribute('aria-expanded') === 'true';
        group.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      });
    });

    // Auto-submit form when a checkbox filter changes
    var form = root.querySelector('#eng-filter-form');
    root.querySelectorAll('[data-eng-auto-submit]').forEach(function(cb){
      cb.addEventListener('change', function(){ if (form) form.submit(); });
    });

    // Sort select — redirect on change
    var sortSelect = root.querySelector('[data-eng-sort]');
    if (sortSelect) {
      sortSelect.addEventListener('change', function(){
        var url = new URL(window.location.href);
        if (sortSelect.value) url.searchParams.set('sort_by', sortSelect.value);
        else url.searchParams.delete('sort_by');
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    }

    // Mobile filter drawer
    var sidebar = root.querySelector('#eng-sidebar');
    var overlay = root.querySelector('[data-eng-filter-overlay]');
    var openBtn = root.querySelector('[data-eng-filter-open]');
    function openDrawer(){
      if (sidebar) sidebar.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    function closeDrawer(){
      if (sidebar) sidebar.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }
    if (openBtn) openBtn.addEventListener('click', openDrawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function(e){
      if (e.key === 'Escape' && sidebar && sidebar.classList.contains('is-open')) closeDrawer();
    });

    // Scroll cue(s) — smooth-scroll down to the product grid (v11.81.2: supports multiple cues)
    var scrollCues = root.querySelectorAll('[data-eng-scroll-cue]');
    scrollCues.forEach(function(scrollCue){
      scrollCue.addEventListener('click', function(e){
        var anchor = root.querySelector('#eng-grid-anchor');
        if (anchor && anchor.scrollIntoView) {
          e.preventDefault();
          anchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });

    // "Explore the collection" — smooth-scroll back up to the grid
    var exploreBtn = root.querySelector('[data-eng-explore]');
    if (exploreBtn) {
      exploreBtn.addEventListener('click', function(e){
        e.preventDefault();
        var grid = root.querySelector('.eng-grid');
        if (grid && grid.scrollIntoView) {
          grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    }
  })();

/* ===== collection-jewellery behaviour ===== */
(function() {
  'use strict';

  /* --- Filter dropdown toggle --- */
  var dropdowns = document.querySelectorAll('[data-filter-dropdown]');

  dropdowns.forEach(function(dropdown) {
    var trigger = dropdown.querySelector('.colj-filter-dropdown__trigger');
    var panel = dropdown.querySelector('.colj-filter-dropdown__panel');
    if (!trigger || !panel) return;

    trigger.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      var isOpen = trigger.getAttribute('aria-expanded') === 'true';

      /* Close all other dropdowns first */
      dropdowns.forEach(function(other) {
        var otherTrigger = other.querySelector('.colj-filter-dropdown__trigger');
        var otherPanel = other.querySelector('.colj-filter-dropdown__panel');
        if (otherTrigger && otherPanel && other !== dropdown) {
          otherTrigger.setAttribute('aria-expanded', 'false');
          otherPanel.hidden = true;
        }
      });

      trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      panel.hidden = isOpen;
    });
  });

  /* --- Close dropdowns on outside click --- */
  document.addEventListener('click', function(e) {
    if (!e.target.closest('[data-filter-dropdown]')) {
      dropdowns.forEach(function(dropdown) {
        var trigger = dropdown.querySelector('.colj-filter-dropdown__trigger');
        var panel = dropdown.querySelector('.colj-filter-dropdown__panel');
        if (trigger && panel) {
          trigger.setAttribute('aria-expanded', 'false');
          panel.hidden = true;
        }
      });
    }
  });

  /* --- Auto-submit filter form on checkbox/radio change --- */
  var filterForm = document.getElementById('colj-filter-form');
  if (filterForm) {
    filterForm.addEventListener('change', function(e) {
      var target = e.target;
      if (target.type === 'checkbox' || target.type === 'radio') {
        filterForm.submit();
      }
    });
  }

  /* --- FAQ accordion: close others on open (optional, details/summary handles toggle natively) --- */
  var faqItems = document.querySelectorAll('.colj-faq__item');
  faqItems.forEach(function(item) {
    item.addEventListener('toggle', function() {
      if (item.open) {
        faqItems.forEach(function(other) {
          if (other !== item && other.open) {
            other.open = false;
          }
        });
      }
    });
  });

  /* --- Smooth scroll for anchor links --- */
  document.querySelectorAll('.colj-hero__ctas a[href^="#"]').forEach(function(link) {
    link.addEventListener('click', function(e) {
      var target = document.querySelector(link.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });
})();

/* ===== collection-wedding-rings behaviour ===== */
(function(){
  var qs = document.querySelectorAll('.wrc-root .wrc-faq-q');
  qs.forEach(function(q){
    q.addEventListener('click', function(){
      var item = q.closest('.wrc-faq-item');
      var isOpen = item.classList.contains('open');
      document.querySelectorAll('.wrc-root .wrc-faq-item.open').forEach(function(o){
        if (o !== item) {
          o.classList.remove('open');
          var btn = o.querySelector('.wrc-faq-q');
          if (btn) btn.setAttribute('aria-expanded', 'false');
        }
      });
      item.classList.toggle('open');
      q.setAttribute('aria-expanded', !isOpen);
    });
  });
})();

})();
